import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HomePageBanner } from '../classes/home-page-banner';
import { Globalvar } from '../classes/globalvar';

@Injectable()
export class HomePageBannerService {

  constructor(private http: HttpClient) { }
  HomePageBannerService() {
    // https://joytogive.worldvision.org.ph/joytogive-api/public/api/public/get_site_data
    // return this.http.get<HomePageBanner[]>("https://joytogive.worldvision.org.ph/joytogive-api/public/api/public/get_site_data")
    // return this.http.get<HomePageBanner[]>(Globalvar.ApiUrl +"/GetHomePageBanner?BannerId=")
  }
}
